import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import React, { Component } from "react";
import { PortfolioCard } from "store/card";
import { Info, InfoLinks } from "store/url-builder";
import { DialogWrapper, DialogWrapperType } from "../../../shared/dialog/index";

export interface AdditionalInfoDialogProps {
  open: boolean;
  onClose(): void;
  data: Info;
  portfolioCard: PortfolioCard;
}

export const AdditionalInfoDialog = ({
  data,
  open,
  onClose,
  portfolioCard,
}: AdditionalInfoDialogProps) => {
  let infos: { title: string; content: string }[] = [];

  if (portfolioCard.companyName && portfolioCard.companyName.toString().trim())
    infos.push({ title: "Company Name", content: portfolioCard.companyName });

  if (
    portfolioCard.bussinesName &&
    portfolioCard.bussinesName.toString().trim()
  )
    infos.push({ title: "First Name", content: portfolioCard.bussinesName });

  if (portfolioCard.lastName && portfolioCard.lastName.toString().trim())
    infos.push({ title: "Last Name", content: portfolioCard.lastName });

  if (portfolioCard.jobTitle && portfolioCard.jobTitle.toString().trim())
    infos.push({ title: "Job Title", content: portfolioCard.jobTitle });

  if (portfolioCard.license && portfolioCard.license.toString().trim())
    infos.push({ title: "License", content: portfolioCard.license });

  if (portfolioCard.number && portfolioCard.number.toString().trim()) {
    infos.push({ title: "Phone", content: portfolioCard.number });
  }

  if (portfolioCard.mobile && portfolioCard.mobile.toString().trim()) {
    infos.push({ title: "Mobile", content: portfolioCard.mobile });
  }

  if (portfolioCard.fax && portfolioCard.fax.toString().trim()) {
    infos.push({ title: "Fax", content: portfolioCard.fax });
  }

  if (portfolioCard.email && portfolioCard.email.toString().trim()) {
    infos.push({ title: "E-Mail", content: portfolioCard.email });
  }

  if (portfolioCard.tollFree && portfolioCard.tollFree.toString().trim()) {
    infos.push({ title: "Toll Free", content: portfolioCard.tollFree });
  }

  if (portfolioCard.direct && portfolioCard.direct.toString().trim()) {
    infos.push({ title: "Direct", content: portfolioCard.direct });
  }

  if (data.calendar && data.calendar.toString().trim()) {
    infos.push({ title: "Calendar", content: data.calendar });
  }

  if (data.location && data.location.toString().trim()) {
    infos.push({ title: "Location", content: data.location });
  }

  const switchRender = (title: string, content: string) => {
    let res: Object;
    switch (title) {
      case "Phone":
      case "Mobile":
      case "Direct":
      case "Toll Free":
        res = (
          <a target="_new" href={`tel://${content}`}>
            {content}
          </a>
        );
        break;
      case "E-Mail":
        res = (
          <a target="_new" href={`mailto://${content}`}>
            {content}
          </a>
        );
        break;
      case "Calendar":
        res = (
          <a
            target="_new"
            href={content.startsWith("http") ? content : "http://" + content}
          >
            {content}
          </a>
        );
        break;
      case "Location":
        res = (
          <a
            target="_new"
            href={`https://www.google.com/maps/place/${content}`}
          >
            {content}
          </a>
        );
        break;
      default:
        res = content;
    }
    return res;
  };

  return (
    <DialogWrapper
      type={DialogWrapperType.DEFAULT}
      title="Information"
      open={open}
      onClose={onClose}
      maxWidth={"md"}
    >
      <TableContainer>
        <Table size="small">
          <TableBody>
            {infos.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell width={"50%"}>
                  <b>{row.title}</b>
                </TableCell>
                <TableCell width={"50%"}>
                  {switchRender(row.title, row.content)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </DialogWrapper>
  );
};
